var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
import { request } from './request';
/**
 * 创建指定 URL 前缀的 HTTP 请求方法
 */
export var createRequest = function (_a) {
    var _b = _a.urlPrefix, urlPrefix = _b === void 0 ? '' : _b, context = _a.context, _c = _a.globalError, globalError = _c === void 0 ? true : _c;
    var methods = ['get', 'post', 'put', 'delete'];
    return methods.reduce(function (ret, method) {
        var method_upper = method.toUpperCase();
        ret[method] = function (url, options) {
            var targetUrl = ['https://', 'http://', '//'].some(function (x) { return url.startsWith(x); })
                ? url
                : "".concat(urlPrefix).concat(url);
            return request(targetUrl, __assign(__assign({ context: context, globalError: globalError }, options), { method: method_upper }));
        };
        return ret;
    }, {});
};
